// // import React, { useEffect, useState } from "react";
// // import duplicaLogo from "../AllCorrectPages/images/duplica.png";
// // import "./NavBar.css";
// // import { useNavigate } from "react-router-dom";
// // import { useSelector, useDispatch } from "react-redux";
// // import {
// //   logoutState,
// //   setCurrentUser,
// //   setLoginStatus,
// //   setCookieFun,
// // } from "../REACT/SLICES/Userslice";
// // import { resetState1 } from "../REACT/SLICES/PRCslice";
// // import { jwtDecode } from "jwt-decode";
// // import axios from "axios";
// // import facultyData from "./faculty.json";

// // function NavBar() {
// //   const [googleScriptLoaded, setGoogleScriptLoaded] = useState(false);
// //   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// //   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

// //   const dispatch = useDispatch();
// //   const navigate = useNavigate();
// //   const backendURL = process.env.REACT_APP_backend_url;

// //   const NormalUser = useSelector((state) => state.User.currentUser);
// //   const Prc_User = useSelector((state) => state.PRC.loginStatus);
// //   const userIn = useSelector((state) => state.User.loginStatus);
// //   const isLoggedIn = Prc_User || userIn;

// //   const Role = NormalUser?.role || "";
// //   const userName = NormalUser?.name || "User";
// //   const userEmail = NormalUser?.email || "";

// //   // Get user initials for avatar
// //   const getUserInitials = () => {
// //     if (!userName || userName === "User") return "U";
// //     const names = userName.split(" ");
// //     if (names.length > 1) {
// //       return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
// //     }
// //     return names[0].charAt(0).toUpperCase();
// //   };

// //   const DEPT_CODES = ["01", "02", "03", "04", "05", "10", "12", "24", "32", "66", "67", "69", "62", "72"];
// //   const list_of_department = {
// //     '01': 'CE', '02': 'EEE', '03': 'ME', '04': 'ECE', '05': 'CSE',
// //     '10': 'EIE', '12': 'IT', '24': 'AE', '32': 'CSBS', '66': 'CS-AIML',
// //     '67': 'CS-DS', '69': 'CS-IOT', '62': 'CS-CYS', '72': 'AI-DS'
// //   };
// //   const ROLL_RE = /^(\d{2})(07[15])([aA])(\d{2})([0-9A-Za-z]{2,})$/;
// //   const FACULTY_RE = /^[a-z]+(.[a-z]+)*@vnrvjiet.in$/i;

// //   function validateEmail(email) {
// //     if (typeof email !== "string" || !email) return { ok: false, error: "No email provided." };

// //     email = email.toLowerCase();

// //     if (email === "chandanampavan@gmail.com") return { ok: true, role: "admin" };
// //     if(email === "22071a1216@vnrvjiet.in") return{ ok: true, role: "faculty", rollId: "22071A1216", department: "IT" };

// //     if (!email.endsWith("@vnrvjiet.in")) return { ok: false, error: "Use your @vnrvjiet.in college account." };

// //     if (/\d/.test(email)) {
// //       const rollId = email.slice(0, 10);
// //       const m = ROLL_RE.exec(rollId);
// //       if (!m) return { ok: false, error: "Roll-ID format invalid." };
// //       const dept = m[4];
// //       if (!DEPT_CODES.includes(dept)) return { ok: false, error: `Department code ${dept} unsupported.` };
// //       const department = list_of_department[dept] || "Unknown";
// //       return { ok: true, role: "student", rollId, department };
// //     }

// //     if (!FACULTY_RE.test(email)) return { ok: false, error: "Faculty e-mail format invalid." };

// //     const faculty = facultyData.find((f) => f.Email?.toLowerCase() === email);
// //     if (!faculty) return { ok: false, error: "Faculty not found in records." };

// //     const department = faculty.Department || "Unknown";
// //     const employeeCode = faculty.EmployeeCode || email;

// //     return { ok: true, role: "faculty", department, rollId: employeeCode };
// //   }

// //   useEffect(() => {
// //     const handleResize = () => {
// //       setIsMobileView(window.innerWidth <= 768);
// //     };
// //     window.addEventListener('resize', handleResize);
// //     return () => window.removeEventListener('resize', handleResize);
// //   }, []);

// //   useEffect(() => {
// //     if (!isLoggedIn && !googleScriptLoaded) {
// //       const script = document.createElement("script");
// //       script.src = "https://accounts.google.com/gsi/client";
// //       script.async = true;
// //       script.defer = true;
// //       script.onload = () => {
// //         setGoogleScriptLoaded(true);
// //       };
// //       document.body.appendChild(script);
// //     }
// //   }, [isLoggedIn, googleScriptLoaded]);

// //   useEffect(() => {
// //     if (!isLoggedIn && googleScriptLoaded && window.google && window.google.accounts) {
// //       renderGoogleButton();
// //     } else if (isLoggedIn) {
// //       // Clear the Google Sign-In button when logged in
// //       const signInDiv = document.getElementById("g_id_signin");
// //       if (signInDiv) {
// //         signInDiv.innerHTML = "";
// //       }
// //     }
// //   }, [isLoggedIn, googleScriptLoaded]);

// //   const renderGoogleButton = () => {
// //     if (document.getElementById("g_id_signin")) {
// //       window.google.accounts.id.initialize({
// //         client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
// //         callback: handleCredentialResponse,
// //         ux_mode: "popup",
// //       });
      
// //       // Customize the button based on mobile/desktop view
// //       const buttonConfig = isMobileView ? {
// //         type: "icon",
// //         size: "medium",
// //         shape: "circle",
// //         theme: "outline",
// //         text: "signin_with",
// //       } : {
// //         type: "standard",
// //         theme: "filled_blue",
// //         size: "medium",
// //         text: "signin_with",
// //       };
      
// //       window.google.accounts.id.renderButton(
// //         document.getElementById("g_id_signin"),
// //         buttonConfig
// //       );
      
// //       // Hide the "Sign in with Google" text on mobile
// //       if (isMobileView) {
// //         const signInDiv = document.getElementById("g_id_signin");
// //         if (signInDiv) {
// //           const spans = signInDiv.getElementsByTagName('span');
// //           for (let span of spans) {
// //             if (span.textContent.includes('Sign in with')) {
// //               span.style.display = 'none';
// //             }
// //           }
// //         }
// //       }
// //     }
// //   };

// //   const handleCredentialResponse = (response) => {
// //     try {
// //       const decoded = jwtDecode(response.credential);
// //       const { email_verified, email, name, picture } = decoded;
// //       if (!email_verified || !email) return alert("Google did not return a valid verified email.");
// //       const res = validateEmail(email);
// //       if (!res.ok) return alert(res.error);
// //       const userData = {
// //         name,
// //         email,
// //         role: res.role,
// //         department: res.department ?? null,
// //         rollId: res.rollId ?? null,
// //         picture,
// //       };
// //       dispatch(setCurrentUser(userData));
// //       dispatch(setLoginStatus(true));
// //       dispatch(setCookieFun(userData));
// //       // axios
// //       //   .post(`${backendURL}/loginauth`, { email, user_data: userData }, { withCredentials: true })
// //       //   .then(() => {
// //       //     setIsMobileMenuOpen(false);
// //       //     const lastProjectId = sessionStorage.getItem("lastProjectId");
// //       //     if (lastProjectId) navigate(`/projecthub/view/${lastProjectId}`);
// //       //     else navigate("/studentview");
// //       //     // Clear the Google Sign-In button
// //       //     const signInDiv = document.getElementById("g_id_signin");
// //       //     if (signInDiv) {
// //       //       signInDiv.innerHTML = "";
// //       //     }
// //       //   })
// //       axios
// //   .post(`${backendURL}/loginauth`, { email, user_data: userData }, { withCredentials: true })
// //   .then(() => {
// //     setIsMobileMenuOpen(false);

// //     // Redirect based on user role
// //     if (userData.role === "faculty") {
// //       navigate("/");
// //     } else {
// //       const lastProjectId = sessionStorage.getItem("lastProjectId");
// //       if (lastProjectId) {
// //         navigate(`/projecthub/view/${lastProjectId}`);
// //       } else {
// //         navigate("/studentview");
// //       }
// //     }

// //     // Clear the Google Sign-In button
// //     const signInDiv = document.getElementById("g_id_signin");
// //     if (signInDiv) {
// //       signInDiv.innerHTML = "";
// //     }
// //   })
// //         .catch((err) => console.error("AUTH ERROR:", err.response?.data?.error || err.message));
// //     } catch (err) {
// //       console.error("JWT Decode failed", err);
// //     }
// //   };

// //   const handleLogout = () => {
// //     dispatch(logoutState());
// //     if (Prc_User === true) dispatch(resetState1());
// //     setIsMobileMenuOpen(false);
// //     navigate("/");
// //   };

// //   const handleMenuItemClick = (path) => {
// //     navigate(path);
// //     setIsMobileMenuOpen(false);
// //   };

// //   return (
// //     <div className="duplica-navbar-container">
// //       <div className={`duplica-navbar ${isMobileMenuOpen ? "open" : ""}`}>
// //         {/* Logo and Brand */}
// //         <div className="duplica-logo-section">
// //           <img src={duplicaLogo} alt="Project Hub Logo" />
// //           <span className="duplica-logo-text">Project Hub</span>
// //         </div>

// //         {/* Desktop Navigation Links */}
// //         <div className="duplica-nav-links">
// //           <button onClick={() => navigate("/")}>Home</button>
// //           <button onClick={() => navigate("/abstract")}>Abstract</button>
// //           <button onClick={() => navigate("/filtered")}>Catalog</button>
// //           {isLoggedIn && Role === "student" && (
// //             <button onClick={() => navigate("/studentview")}>Project Panel</button>
// //           )}
// //           {isLoggedIn && Role === "faculty" && (
// //             <>
// //               <button onClick={() => navigate("/fileupload")}>Idea Upload</button>
// //               <button onClick={() => navigate("/editDeletePublish")}>Project Manager</button>
// //             </>
// //           )}
// //           {isLoggedIn && Prc_User && (
// //             <button onClick={() => navigate("/")}>Review Board</button>
// //           )}
// //         </div>

// //         {/* User Actions Section */}
// //         <div className="duplica-user-actions">
// //           {/* Google Sign-In Button - Only visible when not logged in */}
// //           {!isLoggedIn && (
// //             <div className="duplica-google-btn">
// //               <div id="g_id_signin"></div>
// //             </div>
// //           )}

// //           {isLoggedIn && (
// //             <>
// //               {/* User Profile with Avatar */}
// //               <div className="duplica-user-profile">
// //                 <div className="duplica-user-avatar">
// //                   {NormalUser?.picture ? (
// //                     <img src={NormalUser.picture} alt={userName} />
// //                   ) : (
// //                     getUserInitials()
// //                   )}
// //                 </div>
// //                 {!isMobileView && (
// //                   <div className="duplica-user-info">
// //                     <span className="duplica-user-name">{userName}</span>
// //                     <span className="duplica-user-role">{Role}</span>
// //                   </div>
// //                 )}
// //               </div>

// //               {/* Logout Button */}
// //               <button onClick={handleLogout} className="duplica-logout-btn">
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   width="16"
// //                   height="16"
// //                   viewBox="0 0 24 24"
// //                   fill="none"
// //                   stroke="currentColor"
// //                   strokeWidth="2"
// //                   strokeLinecap="round"
// //                   strokeLinejoin="round"
// //                 >
// //                   <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
// //                   <polyline points="16 17 21 12 16 7"></polyline>
// //                   <line x1="21" y1="12" x2="9" y2="12"></line>
// //                 </svg>
// //                 {!isMobileView && <span>Logout</span>}
// //               </button>
// //             </>
// //           )}

// //           {/* Hamburger Menu Button */}
// //           {isMobileView && (
// //             <div
// //               className="duplica-hamburger"
// //               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
// //             >
// //               <div className="duplica-hamburger-icon">
// //                 <span></span>
// //                 <span></span>
// //                 <span></span>
// //               </div>
// //             </div>
// //           )}
// //         </div>

// //         {/* Mobile Menu */}
// //         {isMobileView && (
// //           <div className="duplica-mobile-menu">
// //             {isLoggedIn && (
// //               <div className="duplica-mobile-user">
// //                 <div className="duplica-user-avatar">
// //                   {NormalUser?.picture ? (
// //                     <img src={NormalUser.picture} alt={userName} />
// //                   ) : (
// //                     getUserInitials()
// //                   )}
// //                 </div>
// //                 <div>
// //                   <div className="duplica-user-name">{userName}</div>
// //                   <div className="duplica-user-role">
// //                     {Role} • {NormalUser?.department || ""}
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //             <button onClick={() => handleMenuItemClick("/")}>Home</button>
// //             <button onClick={() => handleMenuItemClick("/abstract")}>Abstract</button>
// //             <button onClick={() => handleMenuItemClick("/filtered")}>Catalog</button>

// //             {isLoggedIn && Role === "student" && (
// //               <button onClick={() => handleMenuItemClick("/studentview")}>
// //                 Project Panel
// //               </button>
// //             )}

// //             {isLoggedIn && Role === "faculty" && (
// //               <>
// //                 <button onClick={() => handleMenuItemClick("/fileupload")}>
// //                   Idea Upload
// //                 </button>
// //                 <button onClick={() => handleMenuItemClick("/editDeletePublish")}>
// //                   Project Manager
// //                 </button>
// //               </>
// //             )}

// //             {isLoggedIn && Prc_User && (
// //               <button onClick={() => handleMenuItemClick("/")}>Review Board</button>
// //             )}

// //             {!isLoggedIn && (
// //               <div className="duplica-mobile-google-btn">
// //                 <div id="g_id_signin_mobile"></div>
// //               </div>
// //             )}

// //             {isLoggedIn && (
// //               <button onClick={handleLogout} className="duplica-mobile-logout">
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   width="16"
// //                   height="16"
// //                   viewBox="0 0 24 24"
// //                   fill="none"
// //                   stroke="currentColor"
// //                   strokeWidth="2"
// //                   strokeLinecap="round"
// //                   strokeLinejoin="round"
// //                   style={{ marginRight: "8px" }}
// //                 >
// //                   <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
// //                   <polyline points="16 17 21 12 16 7"></polyline>
// //                   <line x1="21" y1="12" x2="9" y2="12"></line>
// //                 </svg>
// //                 Logout
// //               </button>
// //             )}
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // }



// // export default NavBar;

// import React, { useEffect, useState } from "react";
// import duplicaLogo from "../AllCorrectPages/images/duplica.png";
// import "./NavBar.css";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   logoutState,
//   setCurrentUser,
//   setLoginStatus,
//   setCookieFun,
// } from "../REACT/SLICES/Userslice";
// import { resetState1 } from "../REACT/SLICES/PRCslice";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// import facultyData from "./faculty.json";

// function NavBar() {
//   const [googleScriptLoaded, setGoogleScriptLoaded] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const backendURL = process.env.REACT_APP_backend_url;

//   const NormalUser = useSelector((state) => state.User.currentUser);
//   const Prc_User = useSelector((state) => state.PRC.loginStatus);
//   const userIn = useSelector((state) => state.User.loginStatus);
//   const isLoggedIn = Prc_User || userIn;

//   const Role = NormalUser?.role || "";
//   const userName = NormalUser?.name || "User";
//   const userEmail = NormalUser?.email || "";

//   // Get user initials for avatar
//   const getUserInitials = () => {
//     if (!userName || userName === "User") return "U";
//     const names = userName.split(" ");
//     if (names.length > 1) {
//       return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
//     }
//     return names[0].charAt(0).toUpperCase();
//   };

//   const DEPT_CODES = ["01", "02", "03", "04", "05", "10", "12", "24", "32", "66", "67", "69", "62", "72"];
//   const list_of_department = {
//     '01': 'CE', '02': 'EEE', '03': 'ME', '04': 'ECE', '05': 'CSE',
//     '10': 'EIE', '12': 'IT', '24': 'AE', '32': 'CSBS', '66': 'CS-AIML',
//     '67': 'CS-DS', '69': 'CS-IOT', '62': 'CS-CYS', '72': 'AI-DS'
//   };
//   const ROLL_RE = /^(\d{2})(07[15])([aA])(\d{2})([0-9A-Za-z]{2,})$/;
//   const FACULTY_RE = /^[a-z]+(.[a-z]+)*@vnrvjiet.in$/i;

//   function validateEmail(email) {
//     if (typeof email !== "string" || !email) return { ok: false, error: "No email provided." };

//     email = email.toLowerCase();

//     if (email === "chandanampavan@gmail.com") return { ok: true, role: "admin" };
//     if(email === "22071a1216@vnrvjiet.in") return{ ok: true, role: "faculty", rollId: "22071A1216", department: "IT" };

//     if (!email.endsWith("@vnrvjiet.in")) return { ok: false, error: "Use your @vnrvjiet.in college account." };

//     if (/\d/.test(email)) {
//       const rollId = email.slice(0, 10);
//       const m = ROLL_RE.exec(rollId);
//       if (!m) return { ok: false, error: "Roll-ID format invalid." };
//       const dept = m[4];
//       if (!DEPT_CODES.includes(dept)) return { ok: false, error: `Department code ${dept} unsupported.` };
//       const department = list_of_department[dept] || "Unknown";
//       return { ok: true, role: "student", rollId, department };
//     }

//     if (!FACULTY_RE.test(email)) return { ok: false, error: "Faculty e-mail format invalid." };

//     const faculty = facultyData.find((f) => f.Email?.toLowerCase() === email);
//     if (!faculty) return { ok: false, error: "Faculty not found in records." };

//     const department = faculty.Department || "Unknown";
//     const employeeCode = faculty.EmployeeCode || email;

//     return { ok: true, role: "faculty", department, rollId: employeeCode };
//   }

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth <= 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     if (!isLoggedIn && !googleScriptLoaded) {
//       const script = document.createElement("script");
//       script.src = "https://accounts.google.com/gsi/client";
//       script.async = true;
//       script.defer = true;
//       script.onload = () => {
//         setGoogleScriptLoaded(true);
//       };
//       document.body.appendChild(script);
//     }
//   }, [isLoggedIn, googleScriptLoaded]);

//   useEffect(() => {
//     if (!isLoggedIn && googleScriptLoaded && window.google && window.google.accounts) {
//       renderGoogleButton();
//     } else if (isLoggedIn) {
//       // Clear the Google Sign-In button when logged in
//       const signInDiv = document.getElementById("g_id_signin");
//       if (signInDiv) {
//         signInDiv.innerHTML = "";
//       }
//     }
//   }, [isLoggedIn, googleScriptLoaded]);

//   const renderGoogleButton = () => {
//     if (document.getElementById("g_id_signin")) {
//       window.google.accounts.id.initialize({
//         client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
//         callback: handleCredentialResponse,
//         ux_mode: "popup",
//       });
      
//       // Customize the button based on mobile/desktop view
//       const buttonConfig = isMobileView ? {
//         type: "icon",
//         size: "medium",
//         shape: "circle",
//         theme: "outline",
//         text: "signin_with",
//       } : {
//         type: "standard",
//         theme: "filled_blue",
//         size: "medium",
//         text: "signin_with",
//       };
      
//       window.google.accounts.id.renderButton(
//         document.getElementById("g_id_signin"),
//         buttonConfig
//       );
      
//       // Hide the "Sign in with Google" text on mobile
//       if (isMobileView) {
//         const signInDiv = document.getElementById("g_id_signin");
//         if (signInDiv) {
//           const spans = signInDiv.getElementsByTagName('span');
//           for (let span of spans) {
//             if (span.textContent.includes('Sign in with')) {
//               span.style.display = 'none';
//             }
//           }
//         }
//       }
//     }
//   };

//   const handleCredentialResponse = (response) => {
//     try {
//       const decoded = jwtDecode(response.credential);
//       const { email_verified, email, name, picture } = decoded;
//       if (!email_verified || !email) return alert("Google did not return a valid verified email.");
//       const res = validateEmail(email);
//       if (!res.ok) return alert(res.error);
//       const userData = {
//         name,
//         email,
//         role: res.role,
//         department: res.department ?? null,
//         rollId: res.rollId ?? null,
//         picture,
//       };
//       dispatch(setCurrentUser(userData));
//       dispatch(setLoginStatus(true));
//       dispatch(setCookieFun(userData));

//       axios
//         .post(`${backendURL}/loginauth`, { email, user_data: userData }, { withCredentials: true })
//         .then(() => {
//           setIsMobileMenuOpen(false);

//           // Redirect based on user role
//           if (userData.role === "faculty") {
//             navigate("/");
//           } else {
//             const lastProjectId = sessionStorage.getItem("lastProjectId");
//             if (lastProjectId) {
//               navigate(`/projecthub/view/${lastProjectId}`);
//             } else {
//               navigate("/studentview");
//             }
//           }

//           // Clear the Google Sign-In button
//           const signInDiv = document.getElementById("g_id_signin");
//           if (signInDiv) {
//             signInDiv.innerHTML = "";
//           }
//         })
//         .catch((err) => console.error("AUTH ERROR:", err.response?.data?.error || err.message));
//     } catch (err) {
//       console.error("JWT Decode failed", err);
//     }
//   };

//   const handleLogout = () => {
//     dispatch(logoutState());
//     if (Prc_User === true) dispatch(resetState1());
//     setIsMobileMenuOpen(false);
//     navigate("/");
//   };

//   const handleMenuItemClick = (path) => {
//     navigate(path);
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <div className="duplica-navbar-container">
//       <div className={`duplica-navbar ${isMobileMenuOpen ? "open" : ""}`}>
//         {/* Logo and Brand */}
//         <div className="duplica-logo-section">
//           <img src={duplicaLogo} alt="Project Hub Logo" />
//           <span className="duplica-logo-text">Project Hub</span>
//         </div>

//         {/* Desktop Navigation Links */}
//         <div className="duplica-nav-links">
//           <button onClick={() => navigate("/")}>Home</button>
//           <button onClick={() => navigate("/abstract")}>Abstract</button>
//           <button onClick={() => navigate("/filtered")}>Catalog</button>
//           {isLoggedIn && Role === "student" && (
//             <button onClick={() => navigate("/studentview")}>Project Panel</button>
//           )}
//           {isLoggedIn && Role === "faculty" && (
//             <>
//               <button onClick={() => navigate("/fileupload")}>Idea Upload</button>
//               <button onClick={() => navigate("/editDeletePublish")}>Project Manager</button>
//             </>
//           )}
//           {isLoggedIn && Prc_User && (
//             <button onClick={() => window.location.href = "https://dev-projecthub.vjstartup.com/reviewPhaseForPRC"}>
//               Review Board
//             </button>
//           )}
//         </div>

//         {/* User Actions Section */}
//         <div className="duplica-user-actions">
//           {/* Google Sign-In Button - Only visible when not logged in */}
//           {!isLoggedIn && (
//             <div className="duplica-google-btn">
//               <div id="g_id_signin"></div>
//             </div>
//           )}

//           {isLoggedIn && (
//             <>
//               {/* User Profile with Avatar */}
//               <div className="duplica-user-profile">
//                 <div className="duplica-user-avatar">
//                   {NormalUser?.picture ? (
//                     <img src={NormalUser.picture} alt={userName} />
//                   ) : (
//                     getUserInitials()
//                   )}
//                 </div>
//                 {!isMobileView && (
//                   <div className="duplica-user-info">
//                     <span className="duplica-user-name">{userName}</span>
//                     <span className="duplica-user-role">{Role}</span>
//                   </div>
//                 )}
//               </div>

//               {/* Logout Button */}
//               <button onClick={handleLogout} className="duplica-logout-btn">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
//                   <polyline points="16 17 21 12 16 7"></polyline>
//                   <line x1="21" y1="12" x2="9" y2="12"></line>
//                 </svg>
//                 {!isMobileView && <span>Logout</span>}
//               </button>
//             </>
//           )}

//           {/* Hamburger Menu Button */}
//           {isMobileView && (
//             <div
//               className="duplica-hamburger"
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             >
//               <div className="duplica-hamburger-icon">
//                 <span></span>
//                 <span></span>
//                 <span></span>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Mobile Menu */}
//         {isMobileView && (
//           <div className="duplica-mobile-menu">
//             {isLoggedIn && (
//               <div className="duplica-mobile-user">
//                 <div className="duplica-user-avatar">
//                   {NormalUser?.picture ? (
//                     <img src={NormalUser.picture} alt={userName} />
//                   ) : (
//                     getUserInitials()
//                   )}
//                 </div>
//                 <div>
//                   <div className="duplica-user-name">{userName}</div>
//                   <div className="duplica-user-role">
//                     {Role} • {NormalUser?.department || ""}
//                   </div>
//                 </div>
//               </div>
//             )}

//             <button onClick={() => handleMenuItemClick("/")}>Home</button>
//             <button onClick={() => handleMenuItemClick("/abstract")}>Abstract</button>
//             <button onClick={() => handleMenuItemClick("/filtered")}>Catalog</button>

//             {isLoggedIn && Role === "student" && (
//               <button onClick={() => handleMenuItemClick("/studentview")}>
//                 Project Panel
//               </button>
//             )}

//             {isLoggedIn && Role === "faculty" && (
//               <>
//                 <button onClick={() => handleMenuItemClick("/fileupload")}>
//                   Idea Upload
//                 </button>
//                 <button onClick={() => handleMenuItemClick("/editDeletePublish")}>
//                   Project Manager
//                 </button>
//               </>
//             )}

//             {isLoggedIn && Prc_User && (
//               <button
//                 onClick={() =>
//                   (window.location.href = "https://dev-projecthub.vjstartup.com/reviewPhaseForPRC")
//                 }
//               >
//                 Review Board
//               </button>
//             )}

//             {!isLoggedIn && (
//               <div className="duplica-mobile-google-btn">
//                 <div id="g_id_signin_mobile"></div>
//               </div>
//             )}

//             {isLoggedIn && (
//               <button onClick={handleLogout} className="duplica-mobile-logout">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ marginRight: "8px" }}
//                 >
//                   <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
//                   <polyline points="16 17 21 12 16 7"></polyline>
//                   <line x1="21" y1="12" x2="9" y2="12"></line>
//                 </svg>
//                 Logout
//               </button>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NavBar;



import React, { useEffect, useState } from "react";
import duplicaLogo from "../AllCorrectPages/images/duplica.png";
import "./NavBar.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  logoutState,
  setCurrentUser,
  setLoginStatus,
  setCookieFun,
} from "../REACT/SLICES/Userslice";
import { resetState1 } from "../REACT/SLICES/PRCslice";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import facultyData from "./faculty.json";

function NavBar() {
  const [googleScriptLoaded, setGoogleScriptLoaded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const backendURL = process.env.REACT_APP_backend_url;

  const NormalUser = useSelector((state) => state.User.currentUser);
  const Prc_User = useSelector((state) => state.PRC.loginStatus);
  const userIn = useSelector((state) => state.User.loginStatus);
  const isLoggedIn = Prc_User || userIn;

  const Role = NormalUser?.role || "";
  const userName = NormalUser?.name || "User";
  const userEmail = NormalUser?.email || "";

  const getUserInitials = () => {
    if (!userName || userName === "User") return "U";
    const names = userName.split(" ");
    if (names.length > 1) {
      return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
    }
    return names[0].charAt(0).toUpperCase();
  };

  const DEPT_CODES = ["01", "02", "03", "04", "05", "10", "12", "24", "32", "66", "67", "69", "62", "72"];
  const list_of_department = {
    '01': 'CE', '02': 'EEE', '03': 'ME', '04': 'ECE', '05': 'CSE',
    '10': 'EIE', '12': 'IT', '24': 'AE', '32': 'CSBS', '66': 'CS-AIML',
    '67': 'CS-DS', '69': 'CS-IOT', '62': 'CS-CYS', '72': 'AI-DS'
  };
  const ROLL_RE = /^(\d{2})(07[15])([aA])(\d{2})([0-9A-Za-z]{2,})$/;
  const FACULTY_RE = /^[a-z]+(.[a-z]+)*@vnrvjiet.in$/i;

  function validateEmail(email) {
    if (typeof email !== "string" || !email) return { ok: false, error: "No email provided." };

    email = email.toLowerCase();

    if (email === "chandanampavan@gmail.com") return { ok: true, role: "admin" };
    if(email === "22071a1216@vnrvjiet.in") return { ok: true, role: "faculty", rollId: "22071A1216", department: "IT" };

    if (!email.endsWith("@vnrvjiet.in")) return { ok: false, error: "Use your @vnrvjiet.in college account." };

    if (/\d/.test(email)) {
      const rollId = email.slice(0, 10);
      const m = ROLL_RE.exec(rollId);
      if (!m) return { ok: false, error: "Roll-ID format invalid." };
      const dept = m[4];
      if (!DEPT_CODES.includes(dept)) return { ok: false, error: `Department code ${dept} unsupported.` };
      const department = list_of_department[dept] || "Unknown";
      return { ok: true, role: "student", rollId, department };
    }

    if (!FACULTY_RE.test(email)) return { ok: false, error: "Faculty e-mail format invalid." };

    const faculty = facultyData.find((f) => f.Email?.toLowerCase() === email);
    if (!faculty) return { ok: false, error: "Faculty not found in records." };

    const department = faculty.Department || "Unknown";
    const employeeCode = faculty.EmployeeCode || email;

    return { ok: true, role: "faculty", department, rollId: employeeCode };
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isLoggedIn && !googleScriptLoaded) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setGoogleScriptLoaded(true);
      };
      document.body.appendChild(script);
    }
  }, [isLoggedIn, googleScriptLoaded]);

  useEffect(() => {
    if (!isLoggedIn && googleScriptLoaded && window.google && window.google.accounts) {
      renderGoogleButton();
    } else if (isLoggedIn) {
      const signInDiv = document.getElementById("g_id_signin");
      if (signInDiv) signInDiv.innerHTML = "";
    }
  }, [isLoggedIn, googleScriptLoaded]);

  const renderGoogleButton = () => {
    if (document.getElementById("g_id_signin")) {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        ux_mode: "popup",
      });

      const buttonConfig = isMobileView
        ? { type: "icon", size: "medium", shape: "circle", theme: "outline", text: "signin_with" }
        : { type: "standard", theme: "filled_blue", size: "medium", text: "signin_with" };

      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        buttonConfig
      );

      if (isMobileView) {
        const signInDiv = document.getElementById("g_id_signin");
        if (signInDiv) {
          const spans = signInDiv.getElementsByTagName('span');
          for (let span of spans) {
            if (span.textContent.includes('Sign in with')) span.style.display = 'none';
          }
        }
      }
    }
  };

  const handleCredentialResponse = (response) => {
    try {
      const decoded = jwtDecode(response.credential);
      const { email_verified, email, name, picture } = decoded;
      if (!email_verified || !email) return alert("Google did not return a valid verified email.");
      const res = validateEmail(email);
      if (!res.ok) return alert(res.error);
      const userData = {
        name,
        email,
        role: res.role,
        department: res.department ?? null,
        rollId: res.rollId ?? null,
        picture,
      };
      dispatch(setCurrentUser(userData));
      dispatch(setLoginStatus(true));
      dispatch(setCookieFun(userData));

      axios
        .post(`${backendURL}/loginauth`, { email, user_data: userData }, { withCredentials: true })
        .then(() => {
          setIsMobileMenuOpen(false);
          if (userData.role === "faculty") navigate("/");
          else {
            const lastProjectId = sessionStorage.getItem("lastProjectId");
            if (lastProjectId) navigate(`/projecthub/view/${lastProjectId}`);
            else navigate("/studentview");
          }
          const signInDiv = document.getElementById("g_id_signin");
          if (signInDiv) signInDiv.innerHTML = "";
        })
        .catch((err) => console.error("AUTH ERROR:", err.response?.data?.error || err.message));
    } catch (err) {
      console.error("JWT Decode failed", err);
    }
  };

  const handleLogout = () => {
    dispatch(logoutState());
    if (Prc_User === true) dispatch(resetState1());
    setIsMobileMenuOpen(false);
    navigate("/");
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="duplica-navbar-container">
      <div className={`duplica-navbar ${isMobileMenuOpen ? "open" : ""}`}>
        {/* Logo and Brand */}
        <div
          className="duplica-logo-section"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={duplicaLogo} alt="Project Hub Logo" />
          <span className="duplica-logo-text">Project Hub</span>
        </div>

        {/* Desktop Navigation Links */}
        <div className="duplica-nav-links">
          <button onClick={() => navigate("/")}>Home</button>
          <button onClick={() => navigate("/abstract")}>Abstract</button>
          <button onClick={() => navigate("/filtered")}>Catalog</button>
          {isLoggedIn && Role === "student" && (
            <button onClick={() => navigate("/studentview")}>Project Panel</button>
          )}
          {isLoggedIn && Role === "faculty" && (
            <>
              <button onClick={() => navigate("/fileupload")}>Idea Upload</button>
              <button onClick={() => navigate("/editDeletePublish")}>Project Manager</button>
            </>
          )}
          {isLoggedIn && Prc_User && (
            <button onClick={() => window.location.href = "https://dev-projecthub.vjstartup.com/reviewPhaseForPRC"}>
              Review Board
            </button>
          )}
        </div>

        {/* User Actions */}
        <div className="duplica-user-actions">
          {!isLoggedIn && <div className="duplica-google-btn"><div id="g_id_signin"></div></div>}

          {isLoggedIn && (
            <>
              <div className="duplica-user-profile">
                <div className="duplica-user-avatar">
                  {NormalUser?.picture ? <img src={NormalUser.picture} alt={userName} /> : getUserInitials()}
                </div>
                {!isMobileView && (
                  <div className="duplica-user-info">
                    <span className="duplica-user-name">{userName}</span>
                    <span className="duplica-user-role">{Role}</span>
                  </div>
                )}
              </div>

              <button onClick={handleLogout} className="duplica-logout-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                {!isMobileView && <span>Logout</span>}
              </button>
            </>
          )}

          {isMobileView && (
            <div className="duplica-hamburger" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <div className="duplica-hamburger-icon"><span></span><span></span><span></span></div>
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobileView && (
          <div className="duplica-mobile-menu">
            {isLoggedIn && (
              <div className="duplica-mobile-user">
                <div className="duplica-user-avatar">
                  {NormalUser?.picture ? <img src={NormalUser.picture} alt={userName} /> : getUserInitials()}
                </div>
                <div>
                  <div className="duplica-user-name">{userName}</div>
                  <div className="duplica-user-role">{Role} • {NormalUser?.department || ""}</div>
                </div>
              </div>
            )}

            <button onClick={() => handleMenuItemClick("/")}>Home</button>
            <button onClick={() => handleMenuItemClick("/abstract")}>Abstract</button>
            <button onClick={() => handleMenuItemClick("/filtered")}>Catalog</button>
            {isLoggedIn && Role === "student" && <button onClick={() => handleMenuItemClick("/studentview")}>Project Panel</button>}
            {isLoggedIn && Role === "faculty" && <>
              <button onClick={() => handleMenuItemClick("/fileupload")}>Idea Upload</button>
              <button onClick={() => handleMenuItemClick("/editDeletePublish")}>Project Manager</button>
            </>}
            {isLoggedIn && Prc_User && <button onClick={() => window.location.href = "https://dev-projecthub.vjstartup.com/reviewPhaseForPRC"}>Review Board</button>}
            {!isLoggedIn && <div className="duplica-mobile-google-btn"><div id="g_id_signin_mobile"></div></div>}
            {isLoggedIn && <button onClick={handleLogout} className="duplica-mobile-logout">Logout</button>}
          </div>
        )}
      </div>
    </div>
  );
}

export default NavBar;
